import { CustomPlayersFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const TeamPersistenceProvider = createStaticContextProvider(
  CustomPlayersFirestorePersistenceContext,
  lazyValue(() =>
    import("./team-persistence").then((module) => module.teamPersistence),
  ),
);
